import { AllRows, Columns, ReportData } from '../result.interface';


export function getFileExportExcesosVelocidad(ctx: any, vrs: number): any {
    
        var exportFileEx = [];
        var bol_datos_ex = false;
        var column_config:Columns[] = [];
    
        var nombre_cell_ch_width = "Nombre".length;
        var duracion_cell_ch_width = "Duracion".length;
        var cant_tramas_cell_ch_width = "Cant. de Tramas".length;
        var tramas_cell_ch_width = "Tramas".length;
        var vel_min_cell_ch_width = "Vel. Min".length;
        var vel_max_cell_ch_width = "Vel. Max".length;
        var pc_cell_ch_width = "Punto cercano".length;
        var zc_cell_ch_width = "Zona Cercana".length;
        var ubicacion_cell_ch_width = "Ubicacion".length;
        var max_vel_cell_ch_width = "Maxima velocidad".length;
        var referencia_cell_ch_width = "Referencia".length;
    
    
        var table_width = ctx.chkDuracion? (1 + (ctx.chkDateHour? 4:2) + 8): (2 + (ctx.chkDateHour? 2:1) + 4);
        var vehiculo_width = ctx.chkDuracion? ((ctx.chkDateHour? 6:4)): (ctx.chkDateHour? 4:3);
    
        var nom_inf = "REPORTE DE EXCESOS DE VELOCIDAD";
    
        var allRows: AllRows[] = [
            {
              cells: [
                { value: nom_inf, ...ctx.headerCellConfig, colSpan: table_width }
              ],
              height: ctx.headerRowsHeight,
            },
            ...ctx.generateEmptyRowsForRowSpan(ctx.headerRowSpan, ctx.headerRowsHeight),
        ];
    
    
    
        ctx.sortedData.forEach((table_data: any) => {
          if(table_data[1].length > 0){
            column_config = [];
            var p_cercano_width = 155;
            var z_cercana_width = 165;
    
            bol_datos_ex = true;
    
            var nom_vehi = table_data[0][1];
            /* if (vm.optionR() == 28) {
                vm.period = data[3][10];
                ruta  = "RUTA : " + data[3][11];
    
                if (vrs == 1) {
                    cc = cc + 1;
                    nom_vehi = nom_vehi + " - " +cc;
                }
            } */
    
            /* Table Header */
    
            var rows: AllRows[] = [
              {
                cells: [
                  { value: nom_inf, ...ctx.headerCellConfig, colSpan: table_width }
                ],
                height: ctx.headerRowsHeight,
              },
              ...ctx.generateEmptyRowsForRowSpan(ctx.headerRowSpan, ctx.headerRowsHeight),
              {
                cells: [
                  { value: "VEHÍCULO", ...ctx.subHeaderVehicleHeaderConfig, colSpan: vehiculo_width },
                  { value: "PERIODO",  ...ctx.subHeaderPeriodHeaderConfig, colSpan: table_width - vehiculo_width },
                ],
                height: ctx.subHeaderHeight,
              },
              {
                cells: [
                  { value: table_data[0][1], ...ctx.subHeaderVehicleContentConfig, colSpan: vehiculo_width, rowSpan: ctx.subHeaderContentRowSpan },
                  { value: ctx.period, ...ctx.subHeaderPeriodContentConfig, colSpan: table_width - vehiculo_width, rowSpan: ctx.subHeaderContentRowSpan },
                ],
                height: ctx.subHeaderContentHeight,
              },
              ...ctx.generateEmptyRowsForRowSpan(ctx.subHeaderContentRowSpan, ctx.subHeaderContentHeight),
            ];
    
            /* Table Body */
    
            var cellsCampos = [];
    
            //----------- CABECERA ------------
            if(ctx.chkDuracion){
    
              cellsCampos.push({ value: "Ítem", ...ctx.colHeaderConfig });
              if (ctx.chkDateHour) {
                cellsCampos.push({ value: "Fecha de Inicio", ...ctx.colHeaderConfig });
                cellsCampos.push({ value: "Hora de Inicio", ...ctx.colHeaderConfig });
                cellsCampos.push({ value: "Fecha de Fin", ...ctx.colHeaderConfig });
                cellsCampos.push({ value: "Hora de Fin", ...ctx.colHeaderConfig });
              } else {
                cellsCampos.push({ value: "Inicio", ...ctx.colHeaderConfig });
                cellsCampos.push({ value: "Fin", ...ctx.colHeaderConfig });
              }
    
              cellsCampos.push({ value: "Duración", ...ctx.colHeaderConfig });
              cellsCampos.push({ value: "Cant. de Tramas", ...ctx.colHeaderConfig, wrap: true });
              cellsCampos.push({ value: "Tramas", ...ctx.colHeaderConfig });
              cellsCampos.push({ value: "Vel. Min.", ...ctx.colHeaderConfig });
              cellsCampos.push({ value: "Vel. Máx.", ...ctx.colHeaderConfig });
              cellsCampos.push({ value: "Punto Cercano", ...ctx.colHeaderConfig });
              cellsCampos.push({ value: "Zona Cercana", ...ctx.colHeaderConfig });
              cellsCampos.push({ value: "Ubicación", ...ctx.colHeaderConfig });
    
            } else {
    
              cellsCampos.push({ value: "Ítem", ...ctx.colHeaderConfig });
              cellsCampos.push({ value: "Nombre", ...ctx.colHeaderConfig });
    
              if (ctx.chkDateHour) {
                cellsCampos.push({ value: "Fecha", ...ctx.colHeaderConfig });
                cellsCampos.push({ value: "Hora", ...ctx.colHeaderConfig });
              } else {
                cellsCampos.push({ value: "Fecha y Hora", ...ctx.colHeaderConfig });
              }
    
              cellsCampos.push({ value: "Máxima Velocidad", ...ctx.colHeaderConfig });
              cellsCampos.push({ value: "Ubicación", ...ctx.colHeaderConfig });
              cellsCampos.push({ value: "Punto Cercano", ...ctx.colHeaderConfig });
              cellsCampos.push({ value: "Referencia", ...ctx.colHeaderConfig });
    
            }
    
            rows.push({
              cells: cellsCampos,
              height: ctx.colsHeaderHeight,
            });
    
            //----------- CONTENIDO / FILAS ------------
    
            if(ctx.chkDuracion){
    
              table_data[1].forEach((item: { latitud: number; longitud: number; nombre: any; fecha_inicial: any; fecha_final: any; PC: any; ZC: any; vel_min: any; vel_max: any; vel_min_can: any; vel_max_can: any; cant_tramas: string; string_tramas: any; duracion: string; }, index: number) => {
                var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";
                var cellsCuerpo = [];
    
                duracion_cell_ch_width = Math.max(duracion_cell_ch_width, (item.duracion??'').toString().length);
                cant_tramas_cell_ch_width = Math.max(cant_tramas_cell_ch_width, (item.cant_tramas??'').toString().length);
                tramas_cell_ch_width = Math.max(tramas_cell_ch_width, (item.string_tramas??'').toString().length);
                vel_min_cell_ch_width = Math.max(vel_min_cell_ch_width, (item.vel_min??'').toString().length);
                vel_max_cell_ch_width = Math.max(vel_max_cell_ch_width, (item.vel_max??'').toString().length);
                pc_cell_ch_width = Math.max(pc_cell_ch_width, (item.PC??'').toString().length);
                zc_cell_ch_width = Math.max(zc_cell_ch_width, (item.ZC??'').toString().length);
                ubicacion_cell_ch_width = Math.max(ubicacion_cell_ch_width, (ubicacion??'').toString().length);
    
                p_cercano_width = Math.max(p_cercano_width, item.PC.length * ctx.char_to_px);
                z_cercana_width = Math.max(z_cercana_width, item.ZC.length * ctx.char_to_px);
    
                cellsCuerpo.push({ value: index + 1, ...ctx.bodyRowsConfig });
    
                if (ctx.chkDateHour) {
                  cellsCuerpo.push({ value: ctx.isChe(item.fecha_inicial), format: "yyyy/mm/dd", ...ctx.bodyRowsConfig });
                  cellsCuerpo.push({ value: ctx.isChs(item.fecha_inicial), format: "hh:mm:ss", ...ctx.bodyRowsConfig });
                  cellsCuerpo.push({ value: ctx.isChe(item.fecha_final), format: "yyyy/mm/dd", ...ctx.bodyRowsConfig });
                  cellsCuerpo.push({ value: ctx.isChs(item.fecha_final), format: "hh:mm:ss", ...ctx.bodyRowsConfig });
                } else {
                  cellsCuerpo.push({ value: ctx.isChe(item.fecha_inicial), format: "yyyy/mm/dd hh:mm:ss", ...ctx.bodyRowsConfig });
                  cellsCuerpo.push({ value: ctx.isChe(item.fecha_final), format: "yyyy/mm/dd hh:mm:ss", ...ctx.bodyRowsConfig });
                }
                cellsCuerpo.push({ value: item.duracion, ...ctx.bodyRowsConfig });
                cellsCuerpo.push({ value: item.cant_tramas, ...ctx.bodyRowsConfig });
                cellsCuerpo.push({ value: item.string_tramas, ...ctx.bodyRowsConfig });
                cellsCuerpo.push({ value: item.vel_min, ...ctx.bodyRowsConfig });
                cellsCuerpo.push({ value: item.vel_max, ...ctx.bodyRowsConfig });
                cellsCuerpo.push({ value: item.PC, ...ctx.bodyRowsConfig });
                cellsCuerpo.push({ value: item.ZC, ...ctx.bodyRowsConfig });
                // cellsCuerpo.push({ value: ubicacion, ...ctx.bodyRowsConfig });
                cellsCuerpo.push({ formula:  'HYPERLINK("http://maps.google.com/maps?q='+ubicacion+'&amp;t=m","'+ubicacion+'")', color:'#0000FF', ...ctx.bodyRowsConfig });
    
    
                rows.push({
                  cells:cellsCuerpo,
                  height: ctx.bodyRowsHeight,
                });
              });
    
            } else {
    
              table_data[1].forEach((item: { latitud: number; longitud: number; nombre: any; fecha: any; PC: any; referencia: any; maxima_velocidad: any; vel_max_can: any; vel_promedio: any; vel_prom_can: any; }, index: number) => {
                var ubicacion = item.latitud.toFixed(6) + "," + item.longitud.toFixed(6) + "";
                var cellsCuerpo = [];
    
                nombre_cell_ch_width = Math.max(nombre_cell_ch_width, (item.nombre??'').toString().length);
                max_vel_cell_ch_width = Math.max(max_vel_cell_ch_width, (item.maxima_velocidad??'').toString().length);
                ubicacion_cell_ch_width = Math.max(ubicacion_cell_ch_width, (ubicacion??'').toString().length);
                pc_cell_ch_width = Math.max(pc_cell_ch_width, (item.PC??'').toString().length);
    
                p_cercano_width = Math.max(p_cercano_width, item.PC.length * ctx.char_to_px);
                referencia_cell_ch_width = Math.max(referencia_cell_ch_width, (item.referencia??'').toString().length);
    
    
    
                cellsCuerpo.push({ value: index + 1, ...ctx.bodyRowsConfig });
                cellsCuerpo.push({ value: item.nombre, ...ctx.bodyRowsConfig });
    
                if (ctx.chkDateHour) {
                  cellsCuerpo.push({ value: ctx.isChe(item.fecha), format: "yyyy/mm/dd", ...ctx.bodyRowsConfig });
                  cellsCuerpo.push({ value: ctx.isChs(item.fecha), format: "hh:mm:ss", ...ctx.bodyRowsConfig });
                } else {
                  cellsCuerpo.push({ value: ctx.isChe(item.fecha), format: "yyyy/mm/dd hh:mm:ss", ...ctx.bodyRowsConfig });
                }
                cellsCuerpo.push({ value: item.maxima_velocidad, ...ctx.bodyRowsConfig });
                // cellsCuerpo.push({ value: ubicacion, ...ctx.bodyRowsConfig });
                cellsCuerpo.push({ formula:  'HYPERLINK("http://maps.google.com/maps?q='+ubicacion+'&amp;t=m","'+ubicacion+'")', color:'#0000FF', ...ctx.bodyRowsConfig });
                cellsCuerpo.push({ value: item.PC, ...ctx.bodyRowsConfig });
                cellsCuerpo.push({ value: item.referencia, ...ctx.bodyRowsConfig });
    
                rows.push({
                  cells:cellsCuerpo,
                  height: ctx.bodyRowsHeight,
                });
              });
    
            }
    
    
            // //********************************************* excel version 2 *********************************
            if ( vrs == 2 ) {
              rows.splice(0, ctx.headerRowSpan);
              rows.push(...ctx.spaceBetweenTables);
              allRows = allRows.concat(rows);
            }
            // //********************************************* excel version 2 *********************************
    
            // //********************************************* excel version 1 *********************************
    
            /* Ancho de Columnas */
    
            if( vrs == 1 ){
              if(ctx.chkDuracion){
    
                column_config = [
                  { width: ctx.w_item },
                ];
                if(ctx.chkDateHour){
                  column_config.push(
                    { width: ctx.w_date_ini_fin },
                    { width: ctx.w_hour_ini_fin },
                    { width: ctx.w_date_ini_fin },
                    { width: ctx.w_hour_ini_fin },
                  )
                } else {
                  column_config.push(
                    { width: ctx.w_date_and_hour },
                    { width: ctx.w_date_and_hour },
                  )
                }
                column_config.push(
                  { width: ctx.calculateColWidth(duracion_cell_ch_width) },
                  { width: ctx.calculateColWidth(cant_tramas_cell_ch_width) },
                  { width: ctx.calculateColWidth(tramas_cell_ch_width) },
                  { width: ctx.calculateColWidth(vel_min_cell_ch_width) },
                  { width: ctx.calculateColWidth(vel_max_cell_ch_width) },
                  { width: ctx.calculateColWidth(pc_cell_ch_width) },
                  { width: ctx.calculateColWidth(zc_cell_ch_width) },
                  { width: ctx.calculateColWidth(ubicacion_cell_ch_width) },
                )
    
              } else {
    
                column_config = [
                  { width: ctx.w_item },
                  { width: ctx.calculateColWidth(nombre_cell_ch_width) },
                ];
                if(ctx.chkDateHour){
                  column_config.push(
                    { width: ctx.w_date },
                    { width: ctx.w_hour },
                  )
                } else {
                  column_config.push(
                    { width: ctx.w_date_and_hour },
                  )
                }
                column_config.push(
                  { width: ctx.calculateColWidth(max_vel_cell_ch_width) },
                  { width: ctx.calculateColWidth(ubicacion_cell_ch_width) },
                  { width: ctx.calculateColWidth(pc_cell_ch_width) },
                  { width: ctx.calculateColWidth(referencia_cell_ch_width) },
                )
    
              }
    
              /* Fin Ancho de Columnas */
    
              exportFileEx.push({
                freezePane: {
                    rowSplit: ctx.headerRowSpan + ctx.subHeaderContentRowSpan + 2
                  },
                columns: column_config,
                title: nom_vehi,
                rows: rows
              });
    
              nombre_cell_ch_width = "Nombre".length;
              duracion_cell_ch_width = "Duracion".length;
              cant_tramas_cell_ch_width = "Cant. de Tramas".length;
              tramas_cell_ch_width = "Tramas".length;
              vel_min_cell_ch_width = "Vel. Min".length;
              vel_max_cell_ch_width = "Vel. Max".length;
              pc_cell_ch_width = "Punto cercano".length;
              zc_cell_ch_width = "Zona Cercana".length;
              ubicacion_cell_ch_width = "Ubicacion".length;
              max_vel_cell_ch_width = "Maxima velocidad".length;
    
            }
            // //********************************************* excel version 1 *********************************
    
    
    
          } // if si hay datos del vehiculo
        });
    
        //NOTA: width * 1.28 (aprox) = Ancho de columna en excel
    
        //********************************************* excel version 2 *********************************
        if (vrs == 2) {
          allRows[0].cells![0].colSpan = table_width;
    
          if(ctx.chkDuracion){
    
            column_config = [
              { width: ctx.w_item },
            ];
            if(ctx.chkDateHour){
              column_config.push(
                { width: ctx.w_date_ini_fin },
                { width: ctx.w_hour_ini_fin },
                { width: ctx.w_date_ini_fin },
                { width: ctx.w_hour_ini_fin },
              )
            } else {
              column_config.push(
                { width: ctx.w_date_and_hour },
                { width: ctx.w_date_and_hour },
              )
            }
            column_config.push(
              { width: ctx.calculateColWidth(duracion_cell_ch_width) },
              { width: ctx.calculateColWidth(cant_tramas_cell_ch_width) },
              { width: ctx.calculateColWidth(tramas_cell_ch_width) },
              { width: ctx.calculateColWidth(vel_min_cell_ch_width) },
              { width: ctx.calculateColWidth(vel_max_cell_ch_width) },
              { width: ctx.calculateColWidth(pc_cell_ch_width) },
              { width: ctx.calculateColWidth(zc_cell_ch_width) },
              { width: ctx.calculateColWidth(ubicacion_cell_ch_width) },
            )
    
          } else {
    
            column_config = [
              { width: ctx.w_item },
              { width: ctx.calculateColWidth(nombre_cell_ch_width) },
            ];
            if(ctx.chkDateHour){
              column_config.push(
                { width: ctx.w_date },
                { width: ctx.w_hour },
              )
            } else {
              column_config.push(
                { width: ctx.w_date_and_hour },
              )
            }
            column_config.push(
              { width: ctx.calculateColWidth(max_vel_cell_ch_width) },
              { width: ctx.calculateColWidth(ubicacion_cell_ch_width) },
              { width: ctx.calculateColWidth(pc_cell_ch_width) },
              { width: ctx.calculateColWidth(referencia_cell_ch_width) },
            )
    
          }
    
          exportFileEx.push({
            freezePane: {
                rowSplit: ctx.headerRowSpan
              },
            columns: column_config,
            title: "Resultado",//data[0][1],
            rows: allRows
          });
    
        }


        console.log("===>exportFileEx getFileExportExcesosVelocidad", exportFileEx);  
        
        if (bol_datos_ex) {
            return exportFileEx;
        } else {
            return [];
        }

}


